import { TextField } from "@mui/material";
import * as React from "react";
import * as whistleBlowService from "source/models/services/whistleBlowService";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "source/components/framework/Dialog/Dialog";
import { useState } from "react";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { AppUtils } from "source/framework/appUtils";
import { SaveDataObj } from "source/framework/saveData";

interface IWhistleBlowEditDescriptionDialogProps {
    id: string;
    unitId: string;
    rowId: string;
    description: string;
    onOk: (description: string, rowId: string) => void;
    onCancel: () => void;
}

interface IWhistleBlowEditDescriptionDialogState {
    description: string;
    descriptionReason: string;
}

export const WhistleBlowEditDescriptionDialog = (props: IWhistleBlowEditDescriptionDialogProps) => {
    const [state, setState] = useState<IWhistleBlowEditDescriptionDialogState>({ description: props.description, descriptionReason: Translations.WhistleBlowDescriptionEditReasonDefaultValue });

    const handleCancel = () => {
        props.onCancel();
    };

    const checkErrors = (): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            if (!state.description) {
                AppUtils.showErrorMessage(Translations.WhistleBlowDescriptionMustBeDefined);
                return resolve(false);
            }
            if (!state.descriptionReason) {
                AppUtils.showErrorMessage(Translations.WhistleBlowDescriptionEditReasonMustBeDefined);
                return resolve(false);
            }
            return resolve(true);
        });
    };

    const getSaveDataFromState = (): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("rowId", props.rowId);
        result.append("id", props.id);
        result.append("unitId", props.unitId);
        result.append("description", state.description);
        result.append("descriptionReason", state.descriptionReason);
        return result;
    };

    const handleSave = async () => {
        if (!await AppUtils.validate(checkErrors)) return null;
        const saveData = getSaveDataFromState();
        //Call server
        const result = await AppUtils.callService(() => whistleBlowService.saveWhistleBlowDescriptionEdit(saveData.obj));
        if (!result) return null;
        if (!result) return;
        props.onOk(state.description, result.rowId);
    };

    return (
        <Dialog
            id="whistleBlowEditDescriptionDialog"
            maxWidth="sm"
            title={Translations.WhistleBlowEditDescription}
            body={<>
                <FormField title={Translations.WhistleBlowDescription} required margin="0">
                    <TextField name="description" title={Translations.WhistleBlowDescription} multiline rows={5} value={state.description} onChange={(e) => setState({ ...state, description: e.target.value })} size="small" fullWidth />
                </FormField>
                <FormField title={Translations.WhistleBlowDescriptionEditReason} required>
                    <TextField name="descriptionReason" title={Translations.WhistleBlowDescriptionEditReason} multiline rows={5} value={state.descriptionReason} onChange={(e) => setState({ ...state, descriptionReason: e.target.value })} size="small" fullWidth />
                </FormField>
            </>}
            buttons={[
                { title: Translations.Cancel, variant: "outlined", onClick: handleCancel },
                { title: Translations.Save, variant: "confirmation", onClick: handleSave },
            ]}
            onClose={handleCancel}
        />
    );
};
